import { createSlice } from '@reduxjs/toolkit';
import { CategoryName, CategoryTypeTitle, WishlistType } from '../types/wishlistShema';
import { getWishlist } from '../services/GetWishlistData';
import { deleteWishlist } from '../services/DeleteWishlist';
import { HYDRATE } from 'next-redux-wrapper';
import { fetchGetShareProducts } from '@entities/Wishlist/module/services/fetchGetShareProducts';
import { fetchAddArrayProduct } from '@entities/Wishlist/module/services/fetchAddArrayProduct';

const initialState: WishlistType = {
  items: [],
  shareItems: [],
  productCategory: [],
  totalItems: null,
  totalSpecSum: null,
  totalSum: null,
  id: null,
  isLoaded: false,
  isLoadedShared: false,
};

export const wishlistProductSlice = createSlice({
  name: 'wishlist',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => {
      return {
        ...state,
        ...action.payload.wishlist,
      };
    });
    builder.addCase(getWishlist.fulfilled, (state, action) => {
      if (action.payload) {
        state.items = action.payload.items;
        state.productCategory = [
          {
            title: CategoryName.All,
            type: null,
            items: action.payload.items,
          },
          ...Object.keys(CategoryTypeTitle).map(itemType => {
            return {
              title: CategoryTypeTitle[itemType],
              type: parseInt(itemType),
              items: action.payload.items.filter(item => item.part === parseInt(itemType)),
            };
          }),
        ];
      }
      state.isLoaded = true;
    });
    builder.addCase(deleteWishlist.fulfilled, (state, action) => {
      if (action.payload) {
        state.items = action.payload.items;
        state.productCategory = [
          {
            title: CategoryName.All,
            type: null,
            items: action.payload.items,
          },
          ...Object.keys(CategoryTypeTitle).map(itemType => {
            return {
              title: CategoryTypeTitle[itemType],
              type: parseInt(itemType),
              items: action.payload.items.filter(item => item.part === parseInt(itemType)),
            };
          }),
        ];
      }
      state.isLoaded = true;
    });
    builder.addCase(fetchGetShareProducts.fulfilled, (state, action) => {
      if (action.payload) {
        state.shareItems = action.payload.items;
      }
      state.isLoadedShared = true;
    });
    builder.addCase(fetchAddArrayProduct.fulfilled, (state, action) => {
      if (action.payload) {
        state.items = action.payload.items;
        state.productCategory = [
          {
            title: CategoryName.All,
            type: null,
            items: action.payload.items,
          },
          ...Object.keys(CategoryTypeTitle).map(itemType => {
            return {
              title: CategoryTypeTitle[itemType],
              type: parseInt(itemType),
              items: action.payload.items.filter(item => item.part === parseInt(itemType)),
            };
          }),
        ];
      }
    });
  },
});

export const { actions: wishlistActions } = wishlistProductSlice;
